module.exports = __webpack_public_path__ + "images/8bce070dcbc01c53f8ad9bb138e97759.png";